import { render, staticRenderFns } from "./relievePreservation.vue?vue&type=template&id=16406ae9&"
import script from "./relievePreservation.vue?vue&type=script&lang=js&"
export * from "./relievePreservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports